export const FAKES_MATRIX_TOP_OPTIONS = [10, 20, 30] as const;
export type FakesMatrixTop = (typeof FAKES_MATRIX_TOP_OPTIONS)[number];
export const DEFAULT_FAKES_MATRIX_TOP: FakesMatrixTop = 10;

export const COLOR_THEMES = ['light', 'dark', 'graphite'] as const;
export type ColorTheme = (typeof COLOR_THEMES)[number];
export function isColorTheme(value: unknown): value is ColorTheme {
  return COLOR_THEMES.some((theme) => theme === value);
}

import type { SerpMapView, SerpMapStyle } from '../fakes/serp-appearance.js';
import type { SerpTileMetric } from '../fakes/serp-tile-metrics.js';
export interface UserPreferences {
  colorTheme?: ColorTheme;
  fakesMatrixTop: FakesMatrixTop;
  serpMapView?: SerpMapView;
  serpMapStyle?: SerpMapStyle;
  serpTileMetrics?: SerpTileMetric[];
}
